import {Component} from '@angular/core';

@Component({
  selector: 'app-fill',
  template: `<span class="fill"><ng-content></ng-content></span>`,
  styles: [`:host { flex: 999999 1 auto; text-align: center; }`]
})
export class FillComponent {
}
